import { NgModule } from '@angular/core';

import { FeatherIconDirective } from '@core/directives/core-feather-icons/core-feather-icons';
import { RippleEffectDirective } from '@core/directives/core-ripple-effect/core-ripple-effect.directive';
import { BtnHttpLoadingDirective } from '@core/directives/btn-http-loading/btn-http-loading.directive';

@NgModule({
  declarations: [RippleEffectDirective, FeatherIconDirective, BtnHttpLoadingDirective],
  exports: [RippleEffectDirective, FeatherIconDirective, BtnHttpLoadingDirective]
})
export class CoreDirectivesModule {}
